<template>
  <div id="top">
    <div class="left">
      <div class="logo">
        <img width="300" src="@/assets/image/logo.png" alt=""/>
      </div>
      <div class="menu">
        <el-menu mode="horizontal"
                 background-color="#1E232E"
                 text-color="hsla(0,0%,100%,.68)"
                 active-text-color="hsla(0,0%,100%,1)"
                 :default-active="defaultActive">
          <template>
            <el-menu-item v-for="(menu) in headerMenu" :index="menu.index" :key="menu.name" @click="handleMenuClick(menu)">
              <span class="top-tab-content">{{ menu.label }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
    <div class="right">
      <el-menu ref="profileMenu"
               background-color="#1E232E"
               text-color="white"
               active-text-color="white"
               mode="horizontal"
               @select="handleProfileMenuClick">
        <el-submenu index="10" :active="false">
          <template slot="title">
            <div style="line-height: 60px; float: left">
              <div>
                <span>{{ this.userName }}</span>
              </div>
            </div>
          </template>
          <div style="color: white; padding: 10px">
            <div style="font-size: 14px">账户信息(Account Info)</div>
            <div style="color: #999999; font-size: 13px; margin-top: 5px">{{'账户名称(Account Name): ' + account.name }}</div>
            <div style="color: #999999; font-size: 13px">{{ '账户ID(Account ID): ' + account.id }}</div>
            <div style="color: #999999; font-size: 13px">{{ '账户邮箱(Email): ' + account.associateMail }}</div>
          </div>
          <el-menu-item v-for="(menu) in profileMenu"
                        v-bind:index="menu.name"
                        :key="menu.name"
                        @click="handleMenuClick(menu)">
            <span class="top-sub-tab-content">{{ menu.label }}</span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import {sspApi} from '@/api'
import store from '@/data/store'

export default {
  name: 'qxTop',
  computed: {
    userName: function () {
      return this.$store.state.accountInfo.name
    },
    account: function () {
      return this.$store.state.accountInfo
    },
    defaultActive: function () {
      let tab1 = ['media', 'adzone']
      let tab2 = ['report']
      let tab3 = ['accessGuide']
      let tab4 = ['account']

      if (_.find(tab1, (it) => this.$route.name.includes(it))) {
        return '1'
      } else if (_.find(tab2, (it) => this.$route.name.includes(it))) {
        return '2'
      } else if (_.find(tab3, (it) => this.$route.name.includes(it))) {
        return '3'
      } else if (_.find(tab4, (it) => this.$route.name.includes(it))) {
        return '4'
      } else {
        return '5'
      }
    },
  },
  data: function () {
    return {
      headerMenu: [
        {index: '1', name: 'media', label: '流量管理(Traffic Management)', action: {type: 'route', val: 'media'}},
        {index: '2', name: 'report', label: '数据报表(Data Chart)', action: {type: 'route', val: 'report'}},
        {index: '3', name: 'accessGuide', label: '接入指引(Access Guide)', action: {type: 'route', val: 'accessGuide'}},
        {index: '4', name: 'account', label: '账户管理(Account Management)', action: {type: 'route', val: 'account'}}
      ],
      profileMenu: [
        {name: 'logout', label: '登出(Logout)'},
      ],
      enableIframe: false
    }
  },
  methods: {
    handleMenuClick: function (menu) {
      if (menu.name === "logout") {
        this.logout()
        return
      }
      this.$router.push({name: menu.action.val}).catch(() => {})
    },
    logout: function () {
      store.commit('setAccountInfo', {})
      sspApi.logout().then(() => {
        window.location.href = process.env.VUE_APP_SSP_URL
      }).catch(this.$rejectAjaxError())
    },
    handleProfileMenuClick: function () {
      this.$refs.profileMenu.activeIndex = -1
    }
  },
}
</script>

<style scoped>
#top {
  margin: 0 auto;
  background-color: #1E232E;
  height: 60px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  display: flex;
  align-items: center;
}

.logo {
  height: 100vh;
  display: flex;
  width: 300px;
  align-content: center;
  align-items: center;
}

.logo img {
  margin-left: 12px;
}

.menu {
  margin-left: 20px;
}

.right {
  display: flex;
  align-items: center;
}

#top >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 2px solid #409EFF;
  color: #409EFF;
}
</style>
